import Vue from 'vue';
import axios from 'axios';

import store from '../store'
import router from '../router' 
const config = {
  // baseURL: 'http://192.168.24.249:1323/',
  //baseURL: 'https://test-api.sodai.site/',
  //baseURL: 'https://api.okinawa7.com/api/',
  baseURL : 'https://test-api.tsuti.net/api/',
  timeout: 60 * 1000,
  headers: {
    //'Content-Type': 'application/json; charset=utf-8',
    //'X-Requested-With': 'XMLHttpRequest',
  }
};

if (document.domain == 'ds-member.ryukyu.co.jp'){
  config.baseURL = 'https://ds-api.ryukyu.co.jp/api/';
}else if(document.domain == 'member.tsuti.net'){
  config.baseURL = 'https://api.tsuti.net/api/';
}else if(document.domain == 'test-member.tsuti.net'){
  config.baseURL = 'https://test-api.tsuti.net/api/';
}

const _axios = axios.create(config);

//リクエスト時の共通化
_axios.interceptors.request.use(
  config => {
   config.headers.common['Authorization'] = 'Bearer ' + store.state.token;
    return config;
  }
)
//レスポンスの共通化
_axios.interceptors.response.use(
  function (response) {
    return response;
  },
  (error) => {
    console.log(error)
    if(error.response.status == 302){
        store.commit('hideOverlay');
        router.push({name:"maintenance", params:error.response.data.resultData});
    }
    else if (error.response.status === 401) {
        store.commit('hideOverlay');
        /**
         * トークンが期限切れの場合 401が発生する
         * エラー画面にリダイレクト
         */
        store.commit('setToken' ,'');
        if(router.currentRoute.name != "Login"){
          //router.push({name:"Login"});
          router.push({name:"Timeout"});
        }
    }
    return Promise.reject(error);
  }
)

Plugin.install = function (Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin